<template>
  <div id="main_menu_user_infos">
    <div v-if="$store.state.core.subscriber == null">
      <b-skeleton width="100%"></b-skeleton>
      <b-skeleton animation="wave" width="90%"></b-skeleton>
    </div>
    <div v-if="!isEmpty($store.state.core.subscriber)">
      <div id="main_menu_user_infos_name" class="text-truncate">
        <span v-b-tooltip.hover :title="$store.state.core.subscriber.infos.first_name ? $store.state.core.subscriber.infos.first_name+' '+ $store.state.core.subscriber.infos.last_name : '—'">{{$store.state.core.subscriber.infos.first_name ? $store.state.core.subscriber.infos.first_name+" "+ $store.state.core.subscriber.infos.last_name : '—'}}</span>&nbsp;
      </div>

      <div class="font-weight-light font-14">
        {{ $store.state.core.subscriber.infos.msisdn ? crop_prefix($store.state.core.subscriber.infos.msisdn) : "—" }}
      </div>
    </div>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
export default {
  components: {},
  name: "UserProfilDetails",
  mounted: async function () {
    await subscriber.get_infos();
  }
};
</script>
<style scoped lang="css">
#main_menu_user_infos {
  margin: 30px 0;
  padding: 15px 0;
  border: 2px solid #d3ad13;
  border-left: none;
  border-right: none;
}

#main_menu_user_infos_name{
  font-size: 14px;
  font-weight: bold;
}
</style>
